var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25628 1.13128C7.59799 0.789573 8.15201 0.789573 8.49372 1.13128L13.7437 6.38128C14.0854 6.72299 14.0854 7.27701 13.7437 7.61872L8.49372 12.8687C8.15201 13.2104 7.59799 13.2104 7.25628 12.8687C6.91457 12.527 6.91457 11.973 7.25628 11.6313L11.0126 7.875L0.875001 7.875C0.391752 7.875 0 7.48325 0 7C0 6.51675 0.391752 6.125 0.875001 6.125H11.0126L7.25628 2.36872C6.91457 2.02701 6.91457 1.47299 7.25628 1.13128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.956d1f8b69eb62093797a0fe34b13ccc.svg";
export { ForwardRef as ReactComponent };